import React, { Component } from 'react';
import PropTypes from 'prop-types';

import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Logo from '../Logo';

const DrawerMenu = ({ mainNavigationItems, subNavigationItems, toggleMenu }) =>
    <div key='drawer' onClick={toggleMenu} >
        <div className='schnoffle-drawer-logo'><Logo /></div>
        <List dense>{mainNavigationItems}</List>
        <Divider />
        <List dense>{subNavigationItems}</List>
    </div>;

DrawerMenu.propTypes = {
    mainNavigationItems: PropTypes.arrayOf(PropTypes.element).isRequired,
    subNavigationItems: PropTypes.arrayOf(PropTypes.element),
};

DrawerMenu.defaultProps = {
    subNavigationItems: null,
};

export default DrawerMenu;



// WEBPACK FOOTER //
// ./src/components/header/DrawerMenu.js